"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenderMode = void 0;
exports.defineRenderModeService = defineRenderModeService;
const v1_1 = require("./v1");
__exportStar(require("./context"), exports);
__exportStar(require("./v1"), exports);
var RenderMode;
(function (RenderMode) {
    RenderMode[RenderMode["DEFAULT"] = 0] = "DEFAULT";
    RenderMode[RenderMode["EDIT"] = 1] = "EDIT";
})(RenderMode || (exports.RenderMode = RenderMode = {}));
function defineRenderModeService(renderMode) {
    return {
        id: "audi-render-mode-service",
        create: () => {
            return {
                "1.0.0": () => {
                    return { featureService: new v1_1.RenderModeServiceV1(renderMode) };
                },
            };
        },
    };
}
//# sourceMappingURL=index.js.map